export class Source {
    public id?: string | null;
    public companyId?: string | null;
    public contactId?: string | null;
    public companyTitle?: string;
    public contactName?: string;
    public contactMail?: string;
    public contactSurname?: string;
    public contactTelephone?: string;
    public descriptionEl?: string | null;
    public descriptionEn?: string | null;
    public order?: number | null;
    public sourceCategory?: string;
    public sourceType?: string;
    public subObjectList?: string | null;
    public timeperformed?: string | null;
    public typeOfVisit?: string;
    public $$hashKey?: string;
}
